export default __webpack_public_path__ + "static/media/icon-execution-dark.65e6d40e.svg";